export default "__VITE_ASSET__BOdWdvxg__"